module.exports = __webpack_public_path__ + "450e7cc22a2bd7219e2d83580ed25fb5.pdf";